import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Fade,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import PageHeader from "../../../components/page-layout/PageHeader";
import VendorDispalyCard from "../../../components/pages/stores/VendorDispalyCard";
import { Edit, Map, Payment, Timer } from "@mui/icons-material";
import moment from "moment/moment";
import { grey } from "@mui/material/colors";
import EmptyListUi from "../../../components/EmptyListUi";
import { toast } from "react-hot-toast";
import axiosInstance from "../../../utils/axiosInstance";
import { serviceConfigsUrl, storesUrl, storeMetaUrl } from "../../../utils/urls";
import { errorHandler } from "../../../utils/errorHandler";
import LoadingUI from "../../../components/LoadingUI";

import LoadingImage from "../../../assets/images/creating-store.gif";

const SummaryStep = ({ onFinal, formData, onBack, stepHandler }) => {
  const { vendor = {}, store = {}, service = {}, metaLimits = {} } = formData;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const storeImageUrl = store?.image
    ? URL.createObjectURL(store?.image)
    : "https://images.unsplash.com/photo-1472851294608-062f824d29cc?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D";

  async function handleSubmit() {
    try {
      setIsSubmitting(true);
      // const timer = setTimeout(() => {
      //   stepHandler((prev) => prev + 1);
      //   setTimeout(() => onFinal(), 400);
      // }, 2000);
      // clearTimeout(timer)
      // return;
      // Add Store
      const storeBody = new FormData();
      storeBody.append("name", store.name);
      storeBody.append("latitude", Number(store.latitude));
      storeBody.append("longitude", Number(store.longitude));
      storeBody.append("userId", vendor.id);
      storeBody.append("openTime", `${store.openTime}:00`);
      storeBody.append("closeTime", `${store.closeTime}:00`);
      storeBody.append("status", store.status);
      storeBody.append("platformFee", store.platformFee); //resolved issue
      if (store.image) {
        storeBody.append("image", store.image);
      }
      console.log({ storeBody });

      const storeResponse = await axiosInstance
        .post(storesUrl, storeBody)
        .then((res) => res.data)
        .catch(errorHandler);

      console.log({ storeResponse });
      // 2a. Build the payload from formData.metaLimits
      const { metaLimits = {} } = formData;
      const metaPayload = {
        store_id: storeResponse.id,
        accept_limit: Number(metaLimits.acceptanceLimit),
        request_reject_limit: Number(metaLimits.rejectLimit),
        request_accepted_reject_limit: Number(metaLimits.rejectLimitAfterAccept),
      };

      // 2b. POST to store-meta
      await axiosInstance
        .post(storeMetaUrl, metaPayload)
        .catch(errorHandler);

      // return;
      const serviceConfigBodyList = [];

      service.map((s) =>
        s.types.forEach((type) => {
          const typeBody = {
            serviceId: s.id,
            serviceTypeId: type.id,
            storeId: storeResponse.id,
            price: Number(type.value),
          };
          serviceConfigBodyList.push(typeBody);
        })
      );

      // Submit all service configs in parallel
      await Promise.allSettled(
        serviceConfigBodyList.map((body) =>
          axiosInstance.post(serviceConfigsUrl, body).catch(errorHandler)
        )
      );
    } catch (e) {
      errorHandler(e);
    } finally {
      const timer = setTimeout(() => {
        stepHandler((prev) => prev + 1);
        setTimeout(() => onFinal(), 400);
        clearTimeout(timer)
      }, 2000);
    }
  }

  const loading = (
    <Fade in={isSubmitting} timeout={{ enter: 1000, exit: 700 }} unmountOnExit>
      <div>
        <Box pb={4}>
          <div></div>
          <LoadingUI
            image={
              <img
                src={LoadingImage}
                style={{
                  width: 280,
                  filter:
                    "hue-rotate(180deg) brightness(1.5hue-rotate(30deg) brightness(1.5) invert(1)",
                }}
              />
            }
            text="Hang tight! 🚀 We're setting up your awesome store..."
          />
        </Box>
      </div>
    </Fade>
  );

  const main = (
    <>
      <Typography variant="subtitle1" color="gray" my={2}>
        Vendor Details
      </Typography>
      <VendorDispalyCard
        vendor={vendor}
        buttonTitle={<Edit />}
        buttonOnClick={() => stepHandler(0)}
      />
      <Divider />
      <Typography variant="subtitle1" color="gray" my={2}>
        Store Details
      </Typography>

      <Card sx={{ borderRadius: 4, display: "flex", mb: 4 }}>
        <CardMedia
          component="img"
          sx={{ width: 280, aspectRatio: "16/9" }}
          image={storeImageUrl}
          alt="Store Banner"
        />
        <CardContent sx={{ flex: 1 }}>
          <Box display="flex" direction={"row"} gap={2}>
            <Typography variant="h5">{store.name}</Typography>
            <IconButton
              variant="outlined"
              size="small"
              sx={{ ml: "auto" }}
              onClick={() => stepHandler(1)}
            >
              <Edit color="primary" />
            </IconButton>
            <Chip
              variant="filled"
              color={store.status === "ACTIVE" ? "success" : "warning"}
              label={store.status === "ACTIVE" ? "Active" : "Not Active"}
            />
          </Box>
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <Box display="flex" py={2}>
              <Paper
                elevation={2}
                sx={{
                  px: 2,
                  py: 1,
                  display: "flex",
                  gap: 1,
                  borderRadius: 4,
                }}
              >
                <Timer color="primary" />
                <Typography variant="body1" color="primary">
                  {moment(store.openTime, "HH:mm").format("hh:mm A")}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  —
                </Typography>

                <Typography variant="body1" color="error">
                  {moment(store.closeTime, "HH:mm").format("hh:mm A")}
                </Typography>
              </Paper>
            </Box>

            <Button
              variant="outlined"
              startIcon={<Map />}
              size="large"
              onClick={() => {
                if (store.latitude && store.longitude) {
                  const url = `https://www.google.com/maps?q=${store.latitude},${store.longitude}`;
                  window.open(url, "_blank");
                }
              }}
            >
              See Location
            </Button>

            <Paper
              elevation={2}
              sx={{
                px: 2,
                py: 1,
                display: "flex",
                gap: 1,
                borderRadius: 4,
              }}
            >
              <Payment color="success" />
              <Typography>Platform Fee: ₹{store.platformFee}</Typography>
            </Paper>
          </Box>
        </CardContent>
      </Card>

      <Divider />
      {/* Meta Limits */}
      <Typography variant="subtitle1" color="gray" my={2}>
        Store Meta
      </Typography>
      <Stack spacing={1} mb={4}>
        <Typography>
          Acceptance Limit: {metaLimits.acceptanceLimit || '–'}
        </Typography>
        <Typography>
          Reject Limit: {metaLimits.rejectLimit || '–'}
        </Typography>
        <Typography>
          Reject Limit (After Accept): {metaLimits.rejectLimitAfterAccept || '–'}
        </Typography>
        <Typography>
          Request Reject Count: {metaLimits.requestRejectCount || 0}
        </Typography>
        <Typography>
          Accept Request Reject Count: {metaLimits.acceptRequestRejectCount || 0}
        </Typography>
        <Typography>
          Reject Penalty Amount: ₹{metaLimits.rejectPenaltyAmount || 0}
        </Typography>
        <Typography>
          Accepted Reject Penalty Amount: ₹{metaLimits.acceptedRejectPenaltyAmount || 0}
        </Typography>
      </Stack>


      <Divider />

      <Typography variant="subtitle1" color="gray" my={2}>
        Service Details
      </Typography>

      <Stack gap={3}>
        {service.length ? (
          service.map((s) => {
            return (
              <Stack
                sx={{
                  p: 2,
                  border: "1px red solid",
                  borderColor: grey[400],
                  borderRadius: 4,
                  gap: 1,
                }}
              >
                <Typography>{s.name}</Typography>
                <Stack direction={"row"} gap={2}>
                  {s.types.map((type) => (
                    <Paper
                      key={type.id}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        p: 2,
                        gap: 1,
                        borderRadius: 2,
                      }}
                      elevation={1}
                    >
                      {type.icon && (
                        <img
                          src={type.icon}
                          alt={type.name}
                          width={32}
                          height={32}
                          style={{ borderRadius: 5 }}
                        />
                      )}
                      <Typography
                        variant="h6"
                        fontSize={16}
                        pl={1}
                        sx={{
                          display: "flex",
                          gap: 1,
                        }}
                      >
                        <span>{type.name}</span>
                        <Divider
                          orientation="vertical"
                          variant="middle"
                          flexItem
                        />
                        <span>
                          {type.value > 0 ? (
                            `₹${type.value}`
                          ) : (
                            <Chip
                              label="FREE"
                              color="success"
                              size="small"
                              variant="outlined"
                            />
                          )}
                        </span>
                      </Typography>
                    </Paper>
                  ))}
                </Stack>
              </Stack>
            );
          })
        ) : (
          <EmptyListUi
            text={"No services have been added yet."}
            buttonLabel="Add Services"
            onClick={() => stepHandler(2)}
          />
        )}
      </Stack>
    </>
  );
  return (
    <div>
      <Box pb={4}>
        <PageHeader
          title={"Summary"}
          lead={"Final review before creating your store."}
        />
        {!isSubmitting && main}
        {loading}
      </Box>
      {!isSubmitting && (
        <Stack gap={2} mt={2} flexDirection={"row"} justifyContent={"flex-end"}>
          <Button
            variant="outlined"
            size="small"
            disabled={!onBack}
            onClick={onBack}
          >
            Back
          </Button>

          <Button
            type="submit"
            variant="contained"
            // disabled={!formData.vendor}
            onClick={handleSubmit}
          >
            Create Store
          </Button>
        </Stack>
      )}
    </div>
  );
};

export default SummaryStep;
